module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cell', {
    attrs: {
      "title": _vm.title,
      "value": _vm.currentValue,
      "is-link": !_vm.readonly,
      "value-align": _vm.valueAlign
    },
    nativeOn: {
      "click": function($event) {
        _vm.show($event)
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.displayValue || _vm.placeholder) + "\n  "), _c('span', {
    slot: "icon"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "background-color": "#fff"
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_vm._t("popup-header", null, {
    options: _vm.options,
    value: _vm.currentValue
  }), _vm._v(" "), _c('radio', {
    attrs: {
      "options": _vm.options,
      "fill-mode": false
    },
    on: {
      "on-change": _vm.onValueChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219634ea"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popup-radio/index.vue
// module id = 480
// module chunks = 4